export const STICKY_THEAD_CLASS = 'stickyThead';
export const STICKY_TABLE_CLASS = 'stickyTable';
